// extracted by mini-css-extract-plugin
export const section = "footer-module--section--HLbyK";
export const container = "footer-module--container--BD6BA";
export const pageContent = "footer-module--pageContent--2fPyw";
export const footer = "footer-module--footer--1-rrv";
export const modal = "footer-module--modal--3vfa_";
export const social = "footer-module--social--3KETb";
export const separator = "footer-module--separator--3SRaY";
export const minds = "footer-module--minds--1krM-";